import uiLocale from '../../../utils/UILocale.js';


const translations = {
  avmSingleDeal: uiLocale.getString('component.productlisting.avmSingleDeal'),
  avmMultiDeals: uiLocale.getString('component.productlisting.avmMultiDeals'),
  noReviewsTranslation: uiLocale.getString('component.productlisting.noReviewsLabel'),
  forDeliveryPlaceTranslation: uiLocale.getString('component.productlisting.forLabel'),
  fromDateTranslation: uiLocale.getString('component.productlisting.fromDateLabel'),
  toDateTranslation: uiLocale.getString('component.productlisting.toLabel'),
  mainProductWasPriceTranslation:
    uiLocale.getString('component.productlisting.mainProductWasLabel'),
  mainProductCurrentPriceTranslation: uiLocale.getString('component.productlisting.nowLabel'),
  separateSellingPriceTranslation:
    uiLocale.getString('component.productlisting.separate_selling_price'),
  wasPriceTranslation: uiLocale.getString('component.productlisting.wasLabel'),
  savingsPriceTranslation: uiLocale.getString('component.productlisting.saveLabel'),
  inStorePriceTranslation: uiLocale.getString('component.productlisting.priceInstoreLabel'),
  perMonthTranslation: uiLocale.getString('component.productlisting.perMonthLabel'),
  productDescriptionTitleClosedTranslation:
    uiLocale.getString('component.productlisting.briefProductDescLabel'),
  productDescriptionTitleOpenedTranslation:
    uiLocale.getString('component.productlisting.closeLabel'),
  productDescriptionLinkTranslation:
    uiLocale.getString('component.productlisting.findOutMoreLabel'),
  ourExpertsLoveTranslation: uiLocale.getString('component.productlisting.expertLoveLabel'),
  onlineOnlyTranslation: uiLocale.getString('component.productlisting.onlineOnlyLabel'),
  downloadProductTranslation: uiLocale.getString('component.productlisting.downloadLabel'),
  emailMeBackFirstLineTranslation: uiLocale.getString('component.productlisting.noDeliveryLabel'),
  emailMeBackLinkTranslation: uiLocale.getString('component.productlisting.emailBackLabel'),
  countdownSaleSearchTranslation: uiLocale.getString('component.productlisting.flashSaleLabel'),
  webExclusivePriceTranslation: uiLocale.getString('component.productlisting.webExclusiveLabel'),
  countdownSaleTranslation: uiLocale.getString('component.productlisting.countDownSaleLabel'),
  emailWhenBackForm: {
    title: uiLocale.getString('component.emailbackform.title'),
    legend: uiLocale.getString('component.emailbackform.legend'),
    selectLabel: uiLocale.getString('component.emailbackform.select_label'),
    name: uiLocale.getString('component.emailbackform.name'),
    surname: uiLocale.getString('component.emailbackform.surname'),
    email: uiLocale.getString('component.emailbackform.email'),
    submit: uiLocale.getString('component.emailbackform.submit'),
    mandatoryText: uiLocale.getString('component.emailbackform.mandatory_text'),
    selectTitles: Object.entries(uiLocale.getString('component.emailbackform.select_titles'))
      .map(civilityItem => ({ id: civilityItem[0], label: civilityItem[1] }))
  },
  tooltipTextTranslate: uiLocale.getString('component.comparecheckbox.please_remove_product'),
  searchAgainLink: uiLocale.getString('component.mcd.postcodechecker.search.again.link'),
  changeLocationLink: uiLocale.getString('component.mcd.postcodechecker.change.location.link'),
  locationFoundTopSearchLabel: uiLocale.getString('tourguide.postcodecheck.inline-callout.content'),
  locationFoundFilterSearchLabel:
    uiLocale.getString('component.mcd.postcodechecker.items.available'),
  postcodeCheckerLabel: uiLocale.getString('component.mcd.postcodechecker.check.availability'),
  postcodeCheckerPlaceholder: uiLocale.getString('component.mcd.postcodechecker.enter.postcode'),
  postcodeCheckerPending: uiLocale.getString('component.mcd.postcodechecker.pending'),
  previousSearchesLabel: uiLocale.getString('component.mcd.postcodechecker.previous.searches'),
  wrongLocationInputMessage:
    uiLocale.getString('component.mcd.postcodechecker.no.locations.found.for.input'),
  geolocationOrLabel: uiLocale.getString('component.mcd.postcodechecker.checker.or'),
  geolocationButtonLabel:
    uiLocale.getString('component.mcd.postcodechecker.use.my.current.location'),
  postcodeCheckerSearchingError: uiLocale.getString('component.mcd.postcodechecker.timeouterror'),
  geolocationGatheringError: uiLocale.getString('component.mcd.postcodechecker.geoerror')
};

export default translations;
